export default __webpack_public_path__ + "static/going-galactic-57c38f9cec0db2f43ec822c5198d335d.png";